import { useState, useEffect } from 'react';
import { Text, Group } from '@mantine/core';

export const CountdownSimple: React.FC<{ startTimeInSeconds: number; timeToRunFromStart: number; size?: string }> = ({
  startTimeInSeconds,
  timeToRunFromStart,
  size = 'lg',
}) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Math.floor(Date.now() / 1000) - startTimeInSeconds;
      const remaining = Math.max(timeToRunFromStart - elapsed, 0);
      setTimeLeft(remaining);
      setMounted(true);
    }, 0);

    return () => clearInterval(interval);
  }, [timeToRunFromStart, startTimeInSeconds]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const hours = Math.floor(minutes / 60);
    const displayMinutes = hours > 0 ? minutes % 60 : minutes;
    return [
      hours > 0 ? String(hours).padStart(2, '0') : null,
      String(displayMinutes).padStart(2, '0'),
      String(remainingSeconds).padStart(2, '0'),
    ]
      .filter(Boolean)
      .join(':');
  };

  if (!mounted) {
    return <></>;
  }

  return (
    <Group gap="5px" align="center">
      <Text size={size} fw={500} c={timeLeft > 300 ? 'gray.1' : 'red'}>
        {timeLeft > 0 ? formatTime(timeLeft) : "Time's up!"}
      </Text>
    </Group>
  );
};
